<template>
  <div>
    <v-card class="my-2">
      <v-row class="px-4">
        <v-col lg="4" md="4" sm="4" class="col-12">
          <v-menu ref="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-combobox
                v-model="dateRangeText"
                label="Rango Fechas"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
              ></v-combobox>
            </template>
            <v-date-picker v-model="dates" range no-title scrollable color="primary"> </v-date-picker>
          </v-menu>
        </v-col>
        <v-col lg="4" md="4" sm="4" class="col-12">
          <v-select v-model="sector" :items="sectorOpciones" label="Seleccione Sector"> </v-select>
        </v-col>
        <v-col lg="4" md="4" sm="4" class="col-12">
          <v-select v-model="comedor" :items="comedorOpciones" label="Seleccione Comedor"> </v-select>
        </v-col>
      </v-row>
    </v-card>
    <v-card flat class="mb-7" v-for="(el, i) in DashboardComedorChartSeries" :key="i">
      <v-card-text class="pa-5">
        <div class="d-sm-flex align-center">
          <div>
            <h3 class="title font-weight-regular">Gráfico</h3>
            <h6 class="subtitle-2 font-weight-light">Ranking de {{ el.name }} (Top 5)</h6>
          </div>
          <v-spacer></v-spacer>
          <div class="ml-auto">
            <div class="d-flex align-center">
              <div class="d-flex align-center px-2">
                <span class="info--text">
                  <span class="overline">
                    <i class="fa fa-circle mx-2"></i>
                  </span>
                  <span class="font-weight-regular">{{ el.name | capitalize }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div v-show="elementVisible">
          <vue-apex-charts
            type="bar"
            height="308px"
            :options="DashboardComedorChartOptions[i]"
            :series="[el]"
          ></vue-apex-charts>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import DashboardService from '@/CYC/dashboard/comedor/services/DashboardComedorService';
import moment from 'moment';

export default {
  name: 'DashboardComedorCard',
  data: () => ({
    sectorOpciones: [],
    sector: '',
    comedorOpciones: [],
    comedor: '',
    title: 'TheSalesOverview',
    dashboardService: null,
    elementVisible: false,
    seriesDesayuno: [],
    DashboardComedorChartSeries: [],
    DashboardComedorChartOptions: [],
    structChartOptions: {
      grid: {
        show: true,
        borderColor: 'rgba(0,0,0,.3)',
        strokeDashArray: 2,
        padding: {
          left: 0,
          right: 0,
          bottom: 0
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '22%',
          endingShape: 'flat'
        }
      },
      colors: ['#1e88e5', '#26c6da'],
      fill: {
        type: 'solid',
        opacity: 1
      },
      chart: {
        toolbar: {
          show: false
        },
        sparkline: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: 0
      },
      legend: {
        show: false
      },
      xaxis: {
        type: 'category',
        categories: [],
        labels: {
          style: {
            cssClass: 'grey--text lighten-2--text fill-color'
          }
        }
      },
      yaxis: {
        show: true,
        labels: {
          style: {
            cssClass: 'grey--text lighten-2--text fill-color'
          }
        }
      },
      stroke: {
        curve: 'straight',
        width: 0
      },
      tooltip: {
        theme: 'dark'
      }
    },
    dashboardData: [],
    dates: []
  }),
  computed: {
    dateRangeText() {
      return this.dates.join(' ~ ');
    }
  },
  watch: {
    async dates(val) {
      if (val.length <= 1 || this.comedor == '') return;
      await this.iniciaData();
      this.elementVisible = true;
      // setTimeout(() => (this.elementVisible = true), 1000);
    },
    async comedor() {
      if (this.comedor != '') {
        await this.iniciaData();
        this.elementVisible = true;
        // setTimeout(() => (this.elementVisible = true), 1000);
      }
    },
    async sector() {
      await this.iniciaComedor();
    }
  },
  methods: {
    open() {
      this.$emit('open');
    },
    close() {
      this.$emit('close');
    },
    async iniciaSectores() {
      this.sector = '';
      this.sectorOpciones = [];
      const res = await this.dashboardService.get().execResource('sector', {
        idempresa: localStorage.getItem('emp')
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.sectorOpciones.push({ text: element.descripcion, value: element.idsectorpadre });
        });
        this.sector = this.sectorOpciones[0].value;
      }
    },
    async iniciaComedor() {
      this.open();
      this.comedor = '';
      this.comedorOpciones = [];
      const res = await this.dashboardService.get().execResource('comedor', {
        idempresa: localStorage.getItem('emp'),
        idsectorpadre: this.sector
      });
      if (res.length > 0) {
        this.comedorOpciones.push({ text: 'TODOS', value: 'TODOS' });
        res.forEach((element) => {
          this.comedorOpciones.push({ text: element.comedor, value: element.comedor });
        });
        this.comedor = this.comedorOpciones[0].value;
      }
      this.close();
    },
    async iniciaData() {
      this.open();
      this.dashboardData = [];
      this.DashboardComedorChartSeries = [];
      this.DashboardComedorChartOptions = [];

      const res = await this.dashboardService.get().execResource('dashboard', {
        idempresa: localStorage.getItem('emp'),
        comedor: this.comedor == 'TODOS' ? '' : this.comedor,
        fechainicio: Date.parse(this.dates[0]) < Date.parse(this.dates[1]) ? this.dates[0] : this.dates[1],
        fechafin: Date.parse(this.dates[1]) > Date.parse(this.dates[0]) ? this.dates[1] : this.dates[0]
      });
      this.close();

      this.dashboardData = res[0];

      if (this.dashboardData.length < 1) return;

      const dataSerie = [];
      const dataCat = [];

      const keys = Object.keys(this.dashboardData);

      keys.forEach((el) => {
        const datatmp = [];
        const datacattmp = [];
        this.dashboardData[el].forEach((elem) => {
          datatmp.push(parseInt(elem.contador));
          datacattmp.push(elem.descripcioncorta);
        });
        dataSerie.push({
          name: el,
          data: datatmp
        });
        dataCat.push(datacattmp);
      });

      this.DashboardComedorChartSeries = dataSerie;

      dataCat.forEach((el) => {
        this.DashboardComedorChartOptions.push({
          ...this.structChartOptions,
          ...{
            xaxis: {
              categories: el
            }
          }
        });
      });
      console.log(this.DashboardComedorChartSeries);
      console.log(this.DashboardComedorChartOptions);
    }
  },
  async mounted() {
    this.dates = [
      moment()
        .subtract(1, 'months')
        .endOf('month')
        .format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD')
    ];
    await this.iniciaSectores();
  },
  async created() {
    this.dashboardService = this.$httpService(new DashboardService(), this);
  },
  filters: {
    capitalize: function(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  components: {
    VueApexCharts
  }
};
</script>
